import axios from "axios";

export const PRO_TOKEN_KEY = "pgp_pro_token";
const proApi = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });
proApi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(PRO_TOKEN_KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
proApi.interceptors.response.use((r) => r, (e) => {
  if (e.response?.status === 401 && !String(e.config?.url || "").includes("/auth/")) {
    localStorage.removeItem(PRO_TOKEN_KEY);
    window.location.href = "/professionisti";
  }
  return Promise.reject(e);
});
export const proErr = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg).filter(Boolean).join(" ");
  return "Operazione non riuscita, riprova";
};
export default proApi;
